import { Spinner } from './ui/spinner';

export function PageLoading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="size-8" />
    </div>
  );
}
